import httpRequest from '../../common/lib/http-request';

// *******************
// TRAINING SERVICES
// *******************

function getPublicTrainings() {
    return httpRequest({
        url: '/Training/list/public',
        method: 'GET'
    }, false, process.env.REACT_APP_CORE_NEW_API_URL);
}

function getActiveTrainings(associateId) {
    return httpRequest({
        url: '/Training/' + associateId,
        method: 'GET'
    }, false, process.env.REACT_APP_CORE_NEW_API_URL);
}

function checkRegistrationExists(request) {
    return httpRequest({
        url: '/Training/registration/validate',
        method: 'POST',
        data: request
    }, false, process.env.REACT_APP_CORE_NEW_API_URL);
}

function getTrainingRegistrations(associateId) {
    return httpRequest({
        url: '/Training/registration/associate/' + associateId,
        method: 'GET'
    }, false, process.env.REACT_APP_CORE_NEW_API_URL);
}

function downloadCertificateDocument(request) {
    return httpRequest({
        url: '/Training/registration/certificate',
        method: 'POST',
        data: request
    }, false, process.env.REACT_APP_CORE_NEW_API_URL);
}

function validateQuestionnaireAccessToken(accessToken) {
    return httpRequest({
        url: '/Training/questionnaire/details/' + accessToken,
        method: 'POST'
    }, false, process.env.REACT_APP_CORE_NEW_API_URL);
}

function submitQuestionnaireAnswers(request) {
    return httpRequest({
        url: '/Training/questionnaire/submit',
        method: 'POST',
        data: request
    }, false, process.env.REACT_APP_CORE_NEW_API_URL);
}

const TrainingService = { getActiveTrainings, getPublicTrainings, checkRegistrationExists, getTrainingRegistrations, downloadCertificateDocument, validateQuestionnaireAccessToken, submitQuestionnaireAnswers }

export default TrainingService;